module.exports = __webpack_public_path__ + "assets/fea388eaf6f783204514bd4531f41912.mp3";